import { create } from 'zustand';

export type ToastTone = 'success' | 'error';

export interface Toast {
  id: string;
  message: string;
  tone: ToastTone;
}

/** How long a toast stays on screen before it auto-dismisses. */
const TOAST_DURATION_MS = 2400;

interface UiStore {
  toasts: Toast[];
  notify: (message: string, tone?: ToastTone) => void;
  dismiss: (id: string) => void;
}

export const useUiStore = create<UiStore>((set, get) => ({
  toasts: [],

  notify: (message, tone = 'success') => {
    const id = crypto.randomUUID();
    set((s) => ({ toasts: [...s.toasts, { id, message, tone }] }));

    // Self-expiring so no component has to own dismissal.
    setTimeout(() => get().dismiss(id), TOAST_DURATION_MS);
  },

  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Imperative access for non-React callers. */
export const notify = (message: string, tone: ToastTone = 'success') =>
  useUiStore.getState().notify(message, tone);
